// extracted by mini-css-extract-plugin
export var billingAddress = "_xu-g";
export var contactInfo = "_xu-d";
export var customerInfoContainer = "_xu-c";
export var customerInfoContainerMobile = "_xu-h";
export var customerInfoRow = "_xu-a";
export var customerInfoSection = "_xu-b";
export var fullWidthDividerMobile = "_xu-i";
export var imageContainer = "_xu-1";
export var paymentMethod = "_xu-e";
export var priceText = "_xu-6";
export var priceTextMobile = "_xu-7";
export var product = "_xu-0";
export var productImage = "_xu-2";
export var productInfo = "_xu-4";
export var productMobile = "_xu-9";
export var productTitle = "_xu-8";
export var quantityBadge = "_xu-3";
export var quantityText = "_xu-5";
export var shippingAddress = "_xu-f";